import React, {Component, Fragment} from 'react'
import {Link, withRouter} from 'react-router-dom'
import styles from './Menu.css'
import Framer from "../Framer/Framer"
import {FrameStates, Icon, LIB} from "../../constants/consts-types"
import PropTypes from 'prop-types'
import {TypeMenuList} from "../../constants/consts-prop-types"
import Svg from "../Svg/Svg"
import InfoText from "./InfoText"
import Header from "../Header/Header"

class Menu extends Component {
  static propTypes = {
    menuOpen: PropTypes.bool.isRequired,
    routes: TypeMenuList,
    isThy: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      frame: FrameStates.MENU,
      currentMenuLevel: 0,
      currentMenuId: null,
      menuOpen: false
    }

    this.animateLevel1Items = this.animateLevel1Items.bind(this)
    this.animateLevel2Items = this.animateLevel2Items.bind(this)
    this.resetState = this.resetState.bind(this)
    this.onBackClick = this.onBackClick.bind(this)
    this.onLinkClick = this.onLinkClick.bind(this)
    this.renderLink = this.renderLink.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.menuOpen !== prevProps.menuOpen) {
      if (this.props.menuOpen === true) {
        this.animateLevel1Items(1);
        this.animateLevel2Items(1);
      } else {
        setTimeout(() => {
          // To not be visible during page transition
          this.resetState();
        }, 2000);
        this.animateLevel1Items(0);
        this.animateLevel2Items(0);
      }
    }
  }

  animateLevel1Items(opacity) {
    const primaryItems = this.nodePrimaryList ? this.nodePrimaryList.querySelectorAll('li') : []
    const secondaryItems = this.nodeSecondaryList ? this.nodeSecondaryList.querySelectorAll('li') : []
    const items = [...primaryItems, ...secondaryItems]
    items.forEach((item, idx) => {
      window.TweenLite.to(item, .4, {delay: idx * .1, opacity: opacity, y: `${opacity === 0 ? 10 : 0}px`})
    })
  }

  animateLevel2Items(opacity) {
    const nodeLevel2ListItems = this.nodeLevel2List ? this.nodeLevel2List.querySelectorAll('li') : []

    const items = [...nodeLevel2ListItems]
    items.forEach((item, idx) => {
      window.TweenLite.to(item, .4, {delay: idx * .1, opacity: opacity, y: `${opacity === 0 ? 10 : 0}px`})
    })
  }

  resetState() {
    this.setState({
      frame: FrameStates.MENU,
      currentMenuLevel: 0,
      currentMenuId: null
    })
  }

  onBackClick(event) {
    event.preventDefault()
    this.scrollable.scrollTo(0, 0);
    this.resetState()
  }

  onLinkClick(event, route, menuLevel) {
    if(route.children && route.children.length) {
      event.preventDefault()
    } else {
      return
    }

    if(menuLevel === 0 && this.state.currentMenuLevel === 1) {
      this.resetState()
      return
    } else {
      this.setState({
        currentMenuId: route.url
      })
    }

    if(route.children) {
      this.setState({
        frame: FrameStates.MENU_SUB,
        currentMenuLevel: 1,
        currentMenuId: route.url
      }, () => {
        this.scrollable.scrollTo(0, 0);
        this.animateLevel2Items(1)
      })
    } else {
      this.setState({
        frame: FrameStates.MENU,
        currentMenuLevel: 0,
        currentMenuId: route.url,
      });
      this.props.history.push(`${route.url}`)
    }
  }

  renderInternalLink(route, menuLevel, idx) {
    return (
      <li
        key={idx}
      >
        <Link
          to={`${route.url}`}
          aria-label={`${LIB.goto} ${route.title}`}
          onClick={event => this.onLinkClick(event, route, menuLevel)}
          className={this.state.currentMenuLevel === menuLevel && route.active ? styles.active : styles.link}
          dangerouslySetInnerHTML={{__html: route.title}}
        />
      </li>
    )
  }

  renderExternalLink(route, idx) {
    return (
      <li
        key={idx}
      >
        <a
          href={route.url}
          aria-label={`${LIB.goto} ${route.title}`}
          target="_blank"
          className={styles.link}
          rel={"nofollow noopener"}
          dangerouslySetInnerHTML={{__html: route.title}}
        />
      </li>
    )
  }

  renderLink(route, menuLevel, idx) {
    if(route.external) {
      return this.renderExternalLink(route, idx)
    } else {
      return this.renderInternalLink(route, menuLevel, idx)
    }
  }

  renderSubMenuLink(route, menuLevel, idx) {
    if(route.external) {
      return this.renderExternalLink(route, idx)
    } else {
      return this.renderInternalLink(route, menuLevel, idx)
    }
  }

  render() {
    const {
      menuOpen,
      currentRoute,
      searchOpen,
      onMenuToggle,
      onSearchToggle,
      activeMenuIndex,
      setActiveMenuIndex,
      routes: menu,
      isThy,
    } = this.props;
    const { frame, currentMenuLevel, currentMenuId } = this.state;

    const { practical_menu_info, opening_hours } = currentRoute;

    const linksPrimary = menu
      .filter((r) => r.featured)
      .map((route, idx) => this.renderLink(route, 0, idx));
    const linksSecondary = menu
      .filter((r) => !r.featured)
      .map((route, idx) => this.renderLink(route, 0, idx));

    const route = menu.filter((route) => route.url === currentMenuId);
    const subRoutes =
      route && route[0] && route[0].children ? route[0].children : [];

    // const scrollableHeight = this.scollable ? this.scollable.getBoundingClientRect().height : 0
    // const menuHeight = this.menu ? this.menu.getBoundingClientRect().height : 0
    // const showScrollIndicator = menuHeight > scrollableHeight

    return (
      <nav
        ref={(n) => (this.scrollable = n)}
        className={menuOpen ? styles.menuOpen : styles.Menu}
      >
        <div className={styles.scrollable}>
          <Header
            currentRoute={currentRoute}
            onMenuToggle={onMenuToggle}
            onSearchToggle={onSearchToggle}
            menuOpen={menuOpen}
            searchOpen={searchOpen}
            activeMenuIndex={activeMenuIndex}
            setActiveMenuIndex={setActiveMenuIndex}
            isThy={isThy}
          />

          {/* <Framer
            state={frame}
            className={styles.frame}
          /> */}

          {currentMenuLevel === 1 && (
            <button
              onClick={this.onBackClick}
              aria-label="Back"
              className={styles.buttonBackToTopLevel}
            />
          )}

          <div className={styles.centered}>
            <div ref={(n) => (this.menu = n)} className="container-fluid">
              <div className="row">
                <div className="col-xs-12">
                  <div
                    className={
                      currentMenuLevel < 1
                        ? styles.menuContainer
                        : styles.menuContainerSub
                    }
                  >
                    <div className={styles.menuLevel}>
                      <div className={styles.desktopOnly}>
                        <InfoText data={practical_menu_info} />
                      </div>
                    </div>

                    {/* menu level 0 */}
                    <div
                      className={
                        currentMenuLevel < 1
                          ? styles.menuLevel
                          : styles.menuLevelDiminished
                      }
                    >
                      {menu && (
                        <React.Fragment>
                          <Svg
                            // id={Icon.ARROW_LEFT}
                            id={Icon.ARROW_LONG_LEFT}
                            className={styles.backArrow}
                          />
                          {linksPrimary && linksPrimary.length > 0 && (
                            <Fragment>
                              <div
                                className={styles.OpeningHours}
                                dangerouslySetInnerHTML={{
                                  __html: opening_hours.message,
                                }}
                              />
                              <ul
                                ref={(node) => (this.nodePrimaryList = node)}
                                className={styles.menuItemsPrimary}
                              >
                                {linksPrimary}
                              </ul>
                            </Fragment>
                          )}
                          {linksSecondary && linksSecondary.length > 0 && (
                            <ul
                              ref={(node) => (this.nodeSecondaryList = node)}
                              className={styles.menuItemsSecondary}
                            >
                              {linksSecondary}
                            </ul>
                          )}

                          {/*<div className={styles.mobileOnly}>
                          <InfoText data={practical_menu_info}/>
                        </div>*/}
                        </React.Fragment>
                      )}
                    </div>

                    {/* menu level 1 */}
                    <div className={styles.menuLevel}>
                      {subRoutes && subRoutes.length > 0 && (
                        <ul
                          ref={(node) => (this.nodeLevel2List = node)}
                          className={styles.menuItemsLevel1}
                        >
                          {subRoutes.map((subRoute) => (
                            <li>
                              <div>{subRoute.title}</div>
                              <ul className={styles.menuItemsLevel2}>
                                {subRoute.children &&
                                  !!subRoute.children.length &&
                                  subRoute.children.map((route, idx) =>
                                    this.renderSubMenuLink(route, 1, idx)
                                  )}
                              </ul>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*{showScrollIndicator &&
        <div className={styles.scrollIndicator}/>
        }*/}
        </div>
      </nav>
    );
  }
}

export default withRouter(Menu)



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js